export const getDesignTokens = (isRtl) => ({
  direction: isRtl ? "rtl" : "ltr",
  palette: {
    mode: "light",
    primary: { main: "#006BB6" },
    secondary: { main: "#172C49", faint: "#1d2f4f" },
    info: { main: "#ffffff" },
    text: {
      primary: "#ffffff",
      secondary: "#dddddd",
      input: "#000000",
      lightGrey: "#dddddd",
      darkGrey: "#9c9c9c",
      darkerGrey: "#6b6b6b",
      mediumGrey: "#3f3e3e",
    },
    background: {
      default: "#041937",
      main: "#ffffff",
      faintBlack: "#000000B2",
    },
    action: {
      disabledBackground: "rgba(0, 107, 182, 0.5)",
      disabled: "rgba(255, 255, 255, 0.5)",
      iconHover: "rgba(174, 171, 216, 0.13)",
      iconHoverDarker: "rgba(174, 171, 216, 0.3)",
    },
    error: {
      main: "#d32f2f",
      light: "#d9534f",
    },
    success: {
      main: "#17A150",
      light: "#5cb85c",
    },
    badge: {
      promo: "rgba(99, 102, 241, 0.18)",
      promoText: "#8b93f0",
      daysLeft: "rgba(240, 173, 78, 0.15)",
      daysLeftText: "#f0ad4e",
    },
  },
  typography: {
    fontFamily: isRtl
      ? ['"Univers-Regular"', "sans-serif"].join(",")
      : ['"EMprint-Regular"', "sans-serif"].join(","),
    body0: {
      fontFamily: isRtl ? "Univers-Semibold" : "EMprint-Semibold",
      fontSize: "1.35rem",
    },
    body1: {
      fontFamily: isRtl ? "Univers-Regular" : "EMprint-Regular",
      fontSize: "1.2rem",
    },
    body2: {
      fontFamily: isRtl ? "Univers-Light" : "EMprint-Light",
      fontSize: "1rem",
    },
    button: {
      fontFamily: isRtl ? "Univers-Semibold" : "EMprint-Semibold",
      fontSize: "1.25rem",
      textTransform: "none",
    },
    h6: {
      fontSize: "1.2rem",
    },
    h5: {
      fontFamily: isRtl ? "Univers-Semibold" : "EMprint-Semibold",
    },
    h4: {
      fontFamily: isRtl ? "Univers-Semibold" : "EMprint-Semibold",
      fontSize: "2.5rem",
    },
    fontFamilyBold: isRtl
      ? ['"Univers-Bold"', "sans-serif"].join(",")
      : ['"EMprint-Bold"', "sans-serif"].join(","),
    fontFamilySemiBold: isRtl
      ? ['"Univers-Semibold"', "sans-serif"].join(",")
      : ['"EMprint-Semibold"', "sans-serif"].join(","),
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: (themeParam) => `
        a {
          color: ${themeParam.palette.primary.main};
          font-size: small
        }
      `,
    },
    MuiButton: {
      styleOverrides: {
        root: {
          padding: "0.75rem",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        body: {
          fontFamily: isRtl
            ? ['"Univers-Semibold"', "sans-serif"].join(",")
            : ['"EMprint-Semibold"', "sans-serif"].join(","),
        },
        head: {
          borderColor: "rgba(255, 255, 255, 0.2)",
          borderWidth: "1px",
        },
      },
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          fontFamily: isRtl
            ? ['"Univers-Semibold"', "sans-serif"].join(",")
            : ['"EMprint-Semibold"', "sans-serif"].join(","),
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          backgroundColor: "#041937",
          borderRadius: "8px",
        },
        inputRoot: {
          borderRadius: "8px",
        },
        tag: {
          backgroundColor: "#172C49",
        },
        endAdornment: {
          "& > button": {
            color: "#ffffff",
          },
        },
        listbox: {
          color: "#000000",
        },
        noOptions: {
          color: "#000000",
        },
        loading: {
          color: "#000000",
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: "20px",
        },
      },
    },
    MuiCardHeader: {
      styleOverrides: {
        title: {
          color: "#000000",
        },
      },
    },
  },
});
